"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

var _CardActions = _interopRequireDefault(require("../Card/CardActions"));

var _CardContent = _interopRequireDefault(require("../Card/CardContent"));

var _CardHeader = _interopRequireDefault(require("../Card/CardHeader"));

var _CardHeaderAvatar = _interopRequireDefault(require("../Card/CardHeaderAvatar"));

var _CardHeaderControls = _interopRequireDefault(require("../Card/CardHeaderControls"));

var _CardHeaderTitle = _interopRequireDefault(require("../Card/CardHeaderTitle"));

var _Chip = _interopRequireDefault(require("../Chip/Chip"));

var _ChipFilter = _interopRequireDefault(require("../ChipFilter/ChipFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconPen = function IconPen(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
  }));
};

IconPen.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var EventFeedItemClass = function EventFeedItemClass(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      authorAvatarUrl = _ref.authorAvatarUrl,
      onEditClick = _ref.onEditClick,
      showIndicator = _ref.showIndicator,
      tags = _ref.tags,
      onClickCreateActivity = _ref.onClickCreateActivity,
      onClickCollectFeedback = _ref.onClickCollectFeedback,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "subtitle", "authorAvatarUrl", "onEditClick", "showIndicator", "tags", "onClickCreateActivity", "onClickCollectFeedback"]);

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      overflow: 'hidden'
    }
  }), (0, _themeUi.jsx)(_CardHeader["default"], null, (0, _themeUi.jsx)(_CardHeaderAvatar["default"], {
    url: authorAvatarUrl,
    showIndicator: showIndicator
  }), (0, _themeUi.jsx)(_CardHeaderTitle["default"], {
    title: title,
    subtitle: subtitle
  }), (0, _themeUi.jsx)(_CardHeaderControls["default"], null, onEditClick && (0, _themeUi.jsx)(_ButtonIcon["default"], {
    "aria-label": "Edit class",
    icon: IconPen,
    onClick: onEditClick
  }))), tags.length > 0 && (0, _themeUi.jsx)(_CardContent["default"], {
    variant: "avatar",
    sx: {
      mb: [3, 3]
    }
  }, tags && tags.map(function (tag) {
    return typeof tag === 'string' ? (0, _themeUi.jsx)(_Chip["default"], {
      key: tag,
      sx: {
        mr: 2,
        mb: 2
      }
    }, tag) : (0, _themeUi.jsx)(_react.Fragment, null, tag.onClick ? (0, _themeUi.jsx)(_ChipFilter["default"], {
      onClick: tag.onClick,
      sx: {
        mr: 2,
        mb: 2,
        py: 0,
        height: 3
      },
      key: tag.label
    }, tag.label) : (0, _themeUi.jsx)(_Chip["default"], {
      sx: {
        mr: 2,
        mb: 2
      },
      key: tag.label
    }, tag.label));
  })), (0, _themeUi.jsx)(_CardActions["default"], {
    variant: "avatar",
    sx: _extends({
      borderTopStyle: 'none'
    }, tags.length > 0 && {
      pt: 0
    })
  }, onClickCollectFeedback && (0, _themeUi.jsx)(_Button["default"], {
    onClick: onClickCollectFeedback,
    variant: "text",
    sx: {
      mr: 2
    }
  }, "Check-in with students"), onClickCreateActivity && (0, _themeUi.jsx)(_Button["default"], {
    onClick: onClickCreateActivity,
    variant: "text"
  }, "Create activity")));
};

EventFeedItemClass.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  subtitle: _propTypes["default"].string,
  authorAvatarUrl: _propTypes["default"].string,
  onEditClick: _propTypes["default"].func,
  showIndicator: _propTypes["default"].bool,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    label: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })])),
  onClickCreateActivity: _propTypes["default"].func,
  onClickCollectFeedback: _propTypes["default"].func
};
EventFeedItemClass.defaultProps = {
  showIndicator: false,
  tags: []
};
var _default = EventFeedItemClass;
exports["default"] = _default;